import * as Service from 'types/service';
import AppConstants from 'constants/AppConstants';

export function setTextToPrint(textToPrint: string): BaseTockAction {
  return {
    type: AppConstants.CHITS_SET_TEXT_PRINT,
    payload: textToPrint,
  };
}

// will remove the text to print
export function clearTextToPrint(): BaseTockAction {
  return {
    type: AppConstants.CHITS_CLEAR_TEXT_PRINT,
  };
}

export function openPrintMultipleChitsModal(): BaseTockAction {
  return {
    type: AppConstants.CHITS_OPEN_PRINT_MULTIPLE_MODAL,
  };
}

export function closePrintMultipleChitsModal(): BaseTockAction {
  return {
    type: AppConstants.CHITS_CLOSE_PRINT_MULTIPLE_MODAL,
  };
}

export function openChoosePrinterModal(party: Service.Party): BaseTockAction {
  return {
    type: AppConstants.CHITS_OPEN_CHOOSE_PRINTER_MODAL,
    payload: party,
  };
}

export function closeChosePrinterModal(): BaseTockAction {
  return {
    type: AppConstants.CHITS_CLOSE_CHOOSE_PRINTER_MODAL,
  };
}

export function setPrintForWalkInId(id: number): BaseTockAction {
  return {
    type: AppConstants.CHITS_SET_PRINT_FOR_WALKIN_ID,
    payload: { id },
  };
}

export function clearPrintForWalkInId(): BaseTockAction {
  return {
    type: AppConstants.CHITS_CLEAR_PRINT_FOR_WALKIN_ID,
  };
}
